import * as React from "react"
const SvgHeading2 = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 17a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 16V8q0-.424.288-.712A.97.97 0 0 1 4 7a.97.97 0 0 1 .713.288A.97.97 0 0 1 5 8v3h4V8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 10 7a.97.97 0 0 1 .713.288A.97.97 0 0 1 11 8v8a.97.97 0 0 1-.287.712A.97.97 0 0 1 10 17a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 16v-3H5v3a.97.97 0 0 1-.287.712A.97.97 0 0 1 4 17m10 0a.97.97 0 0 1-.713-.288A.97.97 0 0 1 13 16v-3q0-.825.588-1.412A1.93 1.93 0 0 1 15 11h4V9h-5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 8a.97.97 0 0 1 .287-.712A.97.97 0 0 1 14 7h5q.824 0 1.413.588Q21 8.175 21 9v2q0 .825-.587 1.412A1.93 1.93 0 0 1 19 13h-4v2h5a.97.97 0 0 1 .712.287Q21 15.575 21 16c0 .425-.096.52-.288.712A.97.97 0 0 1 20 17z" />
  </svg>
)
export default SvgHeading2
